function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "01. Fragments / Icons / 32 px / RRSS / Linkedin");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "01.-Fragments-/-Icons-/-32-px-/-RRSS-/-Linkedin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Bg",
  fill: "#D8D8D8",
  opacity: 0,
  x: 0,
  y: 0,
  width: 32,
  height: 32
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,2.66666667 C23.3637967,2.66666667 29.3333333,8.63620334 29.3333333,16 C29.3333333,23.3637967 23.3637967,29.3333333 16,29.3333333 C8.63620334,29.3333333 2.66666667,23.3637967 2.66666667,16 C2.66666667,8.63620334 8.63620334,2.66666667 16,2.66666667 Z M19.7658927,12.2198099 C18.28812,12.2198099 17.3303116,12.9841722 17.0840173,13.5133434 L17.0840173,13.5133434 C17.0809765,13.5002774 17.0566505,13.3957498 16.8377163,12.455001 L16.8377163,12.455001 L14.6757986,12.455001 L14.6765114,21.3333333 L17.3303116,21.3333333 L17.3303116,15.6006302 C17.576606,15.071459 18.0418256,14.5422878 18.7807087,14.5422878 C19.7658927,14.5422878 19.984818,15.3360481 19.984818,16.3649925 L19.984818,16.3649925 L19.984818,21.3333333 L22.6666667,21.3333333 L22.6666667,16.1004104 C22.6666667,13.5133434 21.4625907,12.2198099 19.7658927,12.2198099 Z M13.3124265,12.0548997 L10.6666667,12.0548997 L10.6666667,21.3320111 L13.3124265,21.3320111 L13.3124265,12.0548997 Z M11.8815539,8 C11.1256254,8 10.6666667,8.55293576 10.6666667,9.35160511 C10.6666667,10.1810087 11.1256254,10.7032806 11.8815539,10.7032806 C12.8264662,10.7032806 13.3124265,10.1810087 13.3124265,9.35160511 L13.3124265,9.35160511 L13.3073874,9.21327686 C13.2536666,8.48979776 12.7708831,8 11.8815539,8 Z",
  id: "Fill-6",
  fill: "#141318"
}));

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.96f6e819.svg";
export { ForwardRef as ReactComponent };